<div class="ct origin-top w-screen overflow-x-hidden">
  <!-- @if (showOverlay){
      <div id="overlay" class="overlay  hidden z-[100]">
        <div class="container text-white text-3xl -mt-72 w-full flex flex-col items-center self-center">
          @if (this.tourStep == 1){
            <p class="mb-8 font-bold" i18n>Welcome to the online stand page. Here’s a quick tour to get you started!</p>
          }
          @if (this.tourStep == 2){
            <mat-icon svgIcon="tour:arrow-top-1pt" class="scale-arrow-bottom-top absolute top-48 mr-20 xl:mr-0 self-end !w-24 !h-24 xl:!w-32 xl:!h-32"></mat-icon>
            <p class="mb-8 font-bold" i18n>Use the highlighted arrows in the top right corner to browse other companies in the same industry.</p>
          }
          @if (this.tourStep == 3){
            <p class="mb-8 font-bold" i18n>The bottom right panel is where you can follow this company or request more info.</p>
          }
          <div class="flex flex-row space-x-10 pt-5">
            <button (click)="nextStep()" class="text-white border-white rounded border-2 cursor-pointer mt-5 py-3 px-5 hover:scale-105 hover:bg-gray-800 z-10" i18n>Got it!</button>
          </div>
          @if (this.tourStep == 3) {
            <mat-icon svgIcon="tour:arrow-bot-1pt" class="scale-arrow-top-bottom absolute self-center mt-40 xl:mt-20 xl:ml-20 !w-24 !h-24 xl:!w-32 xl:!h-32"></mat-icon>
          }
        </div>
      </div>
    } -->
  
  <div class="breadcrumbs max-h-10 overflow-hidden w-full text-xs bg-gray-200 text-black md:text-lg md:bg-black md:text-white">
    <!-- ngSkipHydration per via del cache swap per i non canonical. Per i padiglioni principali, viene rimosso un breadcrumb, quindi non combacia con la hydration tview -->
    <breadcrumb ngSkipHydration></breadcrumb>
  </div>
  <div class="main-ct w-full container xl:max-w-none flex flex-col origin-top-left"
    [ngClass]="hideNavBar ? 'min-h-[350px]' : ''"
    (panup)="onPanUp($event)" (pandown)="onPanDown($event)"
    (panleft)="navigateNextStand($event)">
  <div class="top-header-container relative
        flex flex-col items-center
        h-[300px] w-full">
      <div *renderIf="{mediaSelector:'gt-sm'}" class="header-video-bg backgrounds-ct hidden md:block slide-opacity">
        @if (usersService.userAction()) {
          <ng-container *ngTemplateOutlet="videoTpl; context: {bp:'md'}"></ng-container>
        }
      </div>
      <div *renderIf="{mediaSelector:'lt-md'}" class="header-video-bg backgrounds-ct block md:hidden slide-opacity">
        @if (usersService.userAction()) {
          <ng-container *ngTemplateOutlet="videoTpl; context: {bp:'xs'}"></ng-container>
        }
      </div>
      <ng-template #videoTpl let-bp="bp">
        <video #headerVideo autoplay loop playsinline [preload]="'false'" [muted]="'true'" controlsList="nodownload" (fullscreenchange)="changeVideoSource($event.target)">
          @if (!showFullScreenVideo) {
            <ng-container>
              <source [src]="company().video | getStandVideoUrl:'header':'webm':bp" type="video/webm">
              <source [src]="company().video | getStandVideoUrl:'header':'mp4':bp" type="video/mp4">
            </ng-container>
          }
          @if (showFullScreenVideo) {
            <ng-container>
              <source [src]="company().video | getStandVideoUrl:'full':'webm':bp" type="video/webm">
              <source [src]="company().video | getStandVideoUrl:'full':'mp4':bp" type="video/mp4">
            </ng-container>
          }
        </video>
      </ng-template>
      <ng-template #emptyBg>
        <div class="backgrounds-ct slide-opacity"></div>
      </ng-template>
      <div class="absolute h-screen bottom-0"></div>
      <div id="header-content" class="container h-full absolute top-0">
      <div class="top-header-content slide-hide w-full absolute top-0 hidden md:flex items-center origin-top">
        <div class="top-data-wrapper hidden max-w-[85vw] overflow-hidden md:flex gap-x-7 mr-4 text-white text-lg md:text-3xl z-30">
          @if (company().fieldsOfRelevance?.length > 0) {
            <div class="flex items-center gap-x-3">
              <span i18n>Fields:</span>
              @for (field of fieldsOfInterest; track $index) {
                @if (company().fieldsOfRelevance?.includes(field.value)) {
                  <mat-icon
                    class="!w-[20px] !h-[20px] md:!w-[30px] md:!h-[30px]"
                    [matTooltip]="field.label" [svgIcon]="'sectors:' + field.value"
                    matTooltipPosition="below">
                  </mat-icon>
                }
              }
            </div>
          }
          @if (company().materials?.length > 0) {
            <div class="flex gap-x-3">
              <span i18n>Materials:</span>
              @for (label of company().materials | getMaterialsType; track $index; let isLast = $last) {
                <span class="whitespace-nowrap">
                  {{label}}
                  @if (!isLast) {
                    <span i18n>And</span>
                  }
                </span>
              }
            </div>
          }
          </div>
          <div class="hidden md:flex grow justify-end gap-x-5 text-white">
            @if (standService.hasHistory) {
              <button matRipple matRippleColor="rgba(255,255,255,0.08)" [matRippleRadius]="30" [matRippleCentered]="true" [matRippleUnbounded]="true"
                (click)="standService.navigatePreviousStand()" class="w-12 h-12 m-2 hover:-translate-x-1">
                <mat-icon i18n-matTooltip matTooltip="Previous Company" class="!w-12 !h-12" svgIcon="core:arrow_back_ios"></mat-icon>
              </button>
            }
            <!-- BADGE -->
            @if ( company().sponsorLevel && company().sponsorLevel !== 'none' ) {
              <a routerLink="/sponsor">
                <img class="hidden hover:scale-105 cursor-pointer md:block w-28 mt-5 transition-all absolute right-[130px]"
                  [src]="'https://res.cloudinary.com/expometals/image/upload/c_scale,f_auto,q_auto,w_112/v1736333940/assets/badge-cond-'+company().sponsorLevel+'.png'" 
                  alt="Badge for sponsor companies">
              </a>
            }
            @if (!!company().nextCompany) {
              @if (this.tourStep == 2){
              <button matRipple matRippleColor="rgba(255,255,255,1)" [matRippleRadius]="30" [matRippleCentered]="true" [matRippleUnbounded]="true"
                (click)="standService.navigateNextStand()" class="w-12 h-12 m-2 z-[100] hover:translate-x-1 animate-bounce" disabled> <!-- change disabled to dynamic var ? -->
                <mat-icon i18n-matTooltip matTooltip="Next Company" class="!w-12 !h-12" svgIcon="core:arrow_forward_ios"></mat-icon>
              </button>
              }
              @else {
                <button matRipple matRippleColor="rgba(255,255,255,0.08)" [matRippleRadius]="30" [matRippleCentered]="true" [matRippleUnbounded]="true"
                  (click)="standService.navigateNextStand()" class="w-12 h-12 m-2 z-30 hover:translate-x-1">
                  <mat-icon i18n-matTooltip matTooltip="Next Company" class="!w-12 !h-12" svgIcon="core:arrow_forward_ios"></mat-icon>
                </button>
              }
            }
          </div>
        </div>
        <div class="company-name will-change-transform
          absolute top-0 md:top-28 xl:top-[90px]
          left-0 xl:left-[80px]
          w-full md:max-w-[50%] overflow-hidden z-30 flex">
          @if (companyNameHeaderTag) {
            <h1 class="whitespace-nowrap text-ellipsis md:text-2xl xl:text-4xl leading-6 text-white font-bold">
              {{company().fullName}} <br><span id="stand-header-category" class="text-sm xl:text-xl">{{standService.currentCategory().shortName}}</span>
            </h1>
            <!-- MOBILE BADGE -->
            @if ( company().sponsorLevel && company().sponsorLevel !== 'none' ) {
              <a routerLink="/sponsor">
                <img class="block md:hidden w-14 ml-5 mt-1" 
                  [src]="'https://res.cloudinary.com/expometals/image/upload/c_scale,f_auto,q_auto,w_56/v1736333940/assets/badge-cond-'+company().sponsorLevel+'.png'" 
                  alt="Badge for sponsor companies">
              </a>
            }
          }
          @else {
            <div class="lg:text-2xl xl:text-4xl text-white font-bold leading-6">{{company().fullName}}<br><span class="text-sm xl:text-xl">{{standService.currentCategory().shortName}}</span></div>
            @if ( company().sponsorLevel && company().sponsorLevel !== 'none' ) {
              <a routerLink="/sponsor">
                <img class="block md:hidden w-14 ml-5 mt-1" 
                  [src]="'https://res.cloudinary.com/expometals/image/upload/c_scale,f_auto,q_auto,w_56/v1736333940/assets/badge-cond-'+company().sponsorLevel+'.png'" 
                  alt="Badge for sponsor companies">
              </a>
            }
          }
        </div>
        @if (!isFollowedCompany) {
          <expo-button
            [reverseHighlight]="true"
            (click)="toggleFollowedCompany()"
            class="absolute top-6 right-1 z-[100] md:hidden "
          i18n>Follow</expo-button>
        }
        <div class="w-full flex justify-end pt-2 md:hidden">
          @if (isFollowedCompany) {
            <button
              (click)="toggleFollowedCompany()"
              class="!bg-gray-100 !text-gray-400 flex justify-end pt-2 md:hidden"
              i18n="Follow Company button|click to follow" mat-raised-button >Unfollow</button>
          }
        </div>
        <div class="company-logo absolute will-change-transform
          top-12 md:top-[160px] xl:top-[145px]
          left-0 xl:left-[80px]
          h-[120px] w-[120px] xl:h-[200px] xl:w-[200px]
          flex items-center place-content-center
          rounded-md border-solid border border-gray-300
          bg-white origin-top-left z-30">
          <cld-picture
            class="h-[120px] w-[120px] xl:h-[150px] xl:w-[150px]"
            [link]="company() | getCompanyUrl: categoryPath"
            [image]="company().logo"
            [title]="company().fullName"
            [fallbackImage]="companyFallbackImage"
            [sourceMediaSizes]="[
              { w: 120, h: 120, resizeMode: 'pad'},
              { bp: 'xl', w: 150, h: 150, resizeMode: 'pad'}
            ]"
            [lazyload]="true">
          </cld-picture>
          <!-- ### TOP RIGHT CORNER IMG -->
          <!-- <img class="w-28 absolute md:bottom-[130px] md:left-[170px]" src="assets\images\stand\sponsor-badge.png" alt="Badge for sponsor companies"> -->

          <!-- ### TOP LEFT CORNER IMG needs ml-10 -->
          <!-- <img class="w-28 absolute md:bottom-[130px] md:right-[150px]" src="assets\images\stand\sponsor-badge.png" alt="Badge for sponsor companies"> -->
        </div>
        <div class="additional-info
          absolute left-[130px] md:left-[135px] xl:left-[290px]
          top-[45px] md:top-[140px] xl:top-[80px]
          h-[120px] md:h-[150px] xl:h-[220px]
          flex flex-col gap-y-1 justify-end
          text-xs sm:text-sm xl:text-lg text-white z-30">
          <!-- ### TOP ADDITIONAL INFOS -->
          <!-- <img class="w-28" src="assets\images\stand\sponsor-badge.png" alt="Badge for sponsor companies"> -->
          <div class="flex items-center gap-x-2">
            <flag class="m-1" [countryCode]="company().primaryAddress.countryCode"></flag>
            <span>{{company().primaryAddress.countryCode | getCountryName}}</span>
          </div>
          @if (company().foundationYear) {
            <div class="flex items-center gap-x-2">
              <mat-icon class="!w-5 !h-5 md:!w-6 md:!h-6" svgIcon="stand:event"></mat-icon>
              <label i18n>Foundation year:</label>
              <span>{{company().foundationYear}}</span>
            </div>
          }
          @if (company().employees) {
            <div class="flex items-center gap-x-2">
              <mat-icon class="!w-5 !h-5 md:!w-6 md:!h-6" svgIcon="core:people"></mat-icon>
              <label i18n>Number of employees:</label>
              <span>{{company().employees}}</span>
            </div>
          }
          @if (company().tonsPerYear) {
            <div class="flex items-center gap-x-2">
              <mat-icon class="!w-5 !h-5 md:!w-6 md:!h-6" svgIcon="stand:layers"></mat-icon>
              <label i18n>Tons per year:</label>
              <span>{{company().tonsPerYear}}</span>
            </div>
          }
          @if (company().prodPerYear) {
            <div class="flex items-center gap-x-2">
              <mat-icon class="!w-5 !h-5 md:!w-6 md:!h-6" svgIcon="stand:layers"></mat-icon>
              <label i18n>Prod. per year:</label>
              <span>{{company().prodPerYear}}</span>
            </div>
          }
          @if (company().turnover) {
            <div class="flex items-center gap-x-1">
              <mat-icon class="!w-5 !h-5 md:!w-6 md:!h-6" svgIcon="stand:attach_money"></mat-icon>
              <label i18n>Annual turnover (million EUR):</label>
              <span class="w-10 ">{{company().turnover}}</span>
            </div>
          }
        </div>
        @if (company().video) {
          <button
            class="play-button
            hidden lg:block
            absolute left-[calc(50%-48px)] top-[90px] lg:top-40 z-10
            w-12 h-12 lg:w-24 lg:h-24
            cursor-pointer text-gray-500 text-opacity-70
            hover:text-gray-300"
            (click)="openFullscreen()">
            <mat-icon class="!h-full !w-full" svgIcon="stand:play_circle_black"></mat-icon>
          </button>
        }
        @if (company().description && companyNameHeaderTag && company().accountType !== accountType.basicMember) {
          <div #descriptionTextCt
            class="description-ct absolute bottom-4 right-3 lg:right-0 z-30
            md:h-32
            w-full h-20 lg:h-[7.5rem] md:w-1/2 lg:w-5/12 overflow-hidden
            xl:mr-9
            cursor-pointer text-lg xl:text-xl text-white text-justify leading-5"
            style="contain: strict;"
            (mouseenter)="descriptionEnter()"
            (mouseleave)="descriptionLeave()"
            (click)="toogleDescription()"
            [ngClass]="{'bottom-20': descriptionExpanded}">
            @if (descriptionExpanded) {
              <ng-scrollbar class="sb-accent sb-block" [@readMoreTextUp]="descriptionHover && !descriptionExpanded" #descScrollbar>
                <ng-container *ngTemplateOutlet="tplDescription"></ng-container>
              </ng-scrollbar>
            }
            @if (!descriptionExpanded) {
              <ng-container *ngTemplateOutlet="tplDescription"></ng-container>
            }
            <ng-template #tplDescription>
              <div class="h-full w-full pl-4 pr-4 md:pr-16">
                <div [innerHtml]="company().description"></div>
                <!-- <html-content [content]="company().description" />   -->
                @if (!descriptionExpanded && company().description) {
                  <div class="absolute bottom-0 xl:h-6 w-full bg-gradient-to-t from-gray-900"></div>
                }
                @else {
                  @if(company().companyImage) {
                    <cld-picture
                      class="block w-full max-w-[570px] h-[142px] md:h-[245px] lg:h-[338px] mb-[112px] md:mb-4 mt-4" 
                      [link]="company() | getCompanyUrl: categoryPath"
                      [image]="company().companyImage"
                      [title]="company().fullName"
                      [fallbackImage]="companyFallbackImage"
                      [sourceMediaSizes]="[
                        { w: 253, h: 142, resizeMode: 'pad'},
                        { bp: 'md', w: 435, h: 245, resizeMode: 'pad'},
                        { bp: 'lg', w: 600, h: 338, resizeMode: 'pad'}, 
                        ]"
                      [lazyload]="true">
                    </cld-picture>
                  }
                }
              </div>
            </ng-template>
            @if ((descriptionHover || isTouch) && !descriptionExpanded) {
              <div @readMoreArrowShow class="read-more-arrow">
                <button mat-icon-button (click)="toogleDescription()">
                  <mat-icon svgIcon="core:keyboard_arrow_down"></mat-icon>
                </button>
              </div>
            }
            @if (descriptionExpanded) {
              <div class="hidden md:flex btn-close-header md:bottom-10 lg:bottom-12">
                <button mat-icon-button (click)="toogleDescription()">
                  <mat-icon svgIcon="core:arrow_upward"></mat-icon>
                </button>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
    @if (!hideNavBar) {
      <div  class="navigation-bar mat-elevation-z4 slide-opacity
        hidden md:flex w-full translate-y-0  will-change-transform
        lg:translate-x-[50%] xl:translate-x-[56%] items-center self-end origin-top-left bg-background border-b border-black border-opacity-20  text-black">
        <nav mat-tab-nav-bar mat-stretch-tabs="false" [disablePagination]="true" class="w-full" [tabPanel]="tabPanel">
          @for (page of standService.standPages; track $index) {
            <a mat-tab-link routerLinkActive
              [routerLink]="page.path ? ['./', page.path]: './'"
              [relativeTo]="activatedRoute.parent"
              [rel]="page.rel"
              #rla="routerLinkActive"
              [routerLinkActiveOptions]="{ exact: page.path === null }"
              [active]="rla.isActive" class="flex items-center">
              <span class="inline-flex items-center gap-2">
                <mat-icon [svgIcon]="page.icon"></mat-icon> {{page.label}}
              </span>
            </a>
          }
        </nav>
        <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
        <!-- <div *ngIf="hideNavBar" class="w-full flex flex-col items-center box-border navigation-edits">
        <div class="content">
          <button mat-button (click)="goBack()">
            <mat-icon svgIcon="core:arrow_left"></mat-icon><span>Go back</span>
          </button>
        </div>
      </div> -->
    </div>
  }
</div>
